import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBillingResellerModule } from './customer-billing-reseller/customer-billing-reseller.module';
import { CustomerBillingCustomerModule } from './customer-billing-customer/customer-billing-customer.module';
import { CustomerBillingOtherCustomerModule } from './customer-billing-other-customer/customer-billing-other-customer.module';
import { CustomerBillingInvoiceModule } from './customer-billing-invoice/customer-billing-invoice.module';
import { CustomerBillingCustomerUnitModule } from './customer-billing-customer-unit/customer-billing-customer-unit.module';
import { CustomerBillingPriceModule } from './customer-billing-price/customer-billing-price.module';
import { CustomerBillingNavigationTabsComponent } from './customer-billing-navigation-tabs/customer-billing-navigation-tabs.component';
import { ComponentsModule } from '../components/components.module';
import { UtilitiesModule } from '../utilities/utilities.module';
import { UIRouterModule } from '@uirouter/angular';
import { CustomerBillingStates } from '@fi-app/customer-billing/customer-billing-states';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CustomerBillingHelperService } from '@fi-app/customer-billing/customer-billing-helper.service';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        UtilitiesModule,
        CustomerBillingCustomerModule,
        CustomerBillingCustomerUnitModule,
        CustomerBillingOtherCustomerModule,
        CustomerBillingInvoiceModule,
        CustomerBillingPriceModule,
        CustomerBillingResellerModule,
        UIRouterModule.forChild(CustomerBillingStates),
        MatButtonModule,
        MatIconModule,
    ],
    declarations: [CustomerBillingNavigationTabsComponent],
    providers: [CustomerBillingHelperService],
})
export class CustomerBillingModule {}
